import React from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import { Theme, ThemedText, ThemedView } from '@app/theme';
import Button from "@sharedComponents/Button/Button";
import SystemErrorIcon from "../../../../../assets/Icons/SystemErrorIcon";
import { useTheme } from '@shopify/restyle';

interface KYCErrorCardProps {
  visible: boolean;
  onClose: () => void;
  failedTitle?: string;
  failedSubTitle?: string;
  errorMessage?: string;
}

const KYCErrorCard: React.FC<KYCErrorCardProps> = ({ visible, onClose, failedTitle, failedSubTitle, errorMessage }) => {

  const {colors} = useTheme<Theme>()
  return (
    <BottomSheetContainer
      isVisible={visible}
      close={onClose}
      onClose={onClose}
      dragComponent={undefined}
      closeOnBackdropPress={true}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      showCloseIcon={true}
      containerStyle={{ backgroundColor: '#fefefe' }}
    >
      <ThemedView alignItems={"center"} padding={"lg"}>
        <SystemErrorIcon color={colors['icon-error']} />
        <ThemedText textAlign={"center"} mt={"2xl"} variant={"h5s"} mb={"sm"}>
          {failedTitle || "Verification failed"}
        </ThemedText>
        <ThemedView borderRadius={"sm"} padding={"md"} backgroundColor={"bg-fill-warning"} style={{ width: "100%" }} mb={"2xl"}>
          <ThemedText variant={"b3r"} textAlign={"center"}>
            {failedSubTitle || errorMessage}
          </ThemedText>
        </ThemedView>
        <Button
          label="Try again"
          type="OUTLINED"
          size='MD'
          disabled={false}
          handlePress={onClose}
          bg={'bg-action-primary'}
          textColor={colors['text-primary']}
        />
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default KYCErrorCard; 